"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var shadows = _ref.shadows,
    background = _ref.background,
    typography = _ref.typography;
  return {
    modal: {
      fontFamily: typography.fontFamily,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      minWidth: '350px',
      borderRadius: '5px',
      backgroundColor: background.primary,
      boxShadow: shadows[1],
      padding: '15px',
      outline: 'none'
    }
  };
}, {
  name: 'Modal'
});
exports.useStyles = useStyles;